module.exports = __webpack_public_path__ + "img/agency_banner_3.6cc437bb.png";